import { email } from "../config/regex";

const isEmail = value => email.test(value);

export default isEmail;
